export default "__VITE_ASSET__ideM3eGM__"